import {Component, HostListener, OnInit} from '@angular/core';
import {faCalendarDay} from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment/moment';
import {Router} from '@angular/router';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DraftService} from '../../services/draft.service';
import {GeneralService} from '../../services/general.service';
import {UserDataService} from '../../services/user-data.service';
import {NormalizadorService} from '../../services/normalizador.service';
import {MobilePackService} from '../../services/mobile-pack.service';
import {ListadoActivacionesService} from '../../services/listado-activaciones.service';
import {UserDataModel} from '../../interface/user-data-model';
import { superStatus } from 'src/app/shared/constantes';

// TODO: Obtenerlos del back o agrupar todos los combos
const list_status = [
    {id: 0, label: 'Pendiente'},
    {id: 1, label: 'En procesamiento'},
    {id: 2, label: 'Parcialmente activado'},
    {id: 16, label: 'Activado'},
    {id: 8, label: 'Cancelado'},
    {id: 3, label: 'Borrador'}
];

const list_type = [
    {id: 'convergent', label: 'Fijo y móvil'},
    {id: 'mobile', label: 'Solo móvil'}
];

const list_sort_by_date = [
    {id: 'desc', label: 'Descendente'},
    {id: 'asc', label: 'Ascendente'}
];

@Component({
    selector: 'app-listado-activaciones',
    templateUrl: './listado-activaciones.component.html',
    styleUrls: ['./listado-activaciones.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ListadoActivacionesComponent implements OnInit {
    public loaded = false;
    public isCollapsed = true;
    public orders: any[] = [];
    public ordersFiltered: any[] = [];
    public minDate: Date;
    public maxDate: Date;
    public activationThisMonth: number;
    public requestThisMonth: number;
    public alertThisMonth: number;
    public suspendedThisMonth: number;
    public isAlertView: boolean = false;
    public isPDV: any;
    public date = moment();
    public faCalendarDay = faCalendarDay;
    public formGroup: FormGroup;
    public savingAnnotation = -1;
    public pages: number[] = [];
    public lastPage = 0;
    public body: any = {
        limit: 50,
        page: 1,
        order: {
            created_at: 'desc'
        }
    };
    public listStatus = list_status;
    public listType = list_type;
    public listSortByDate = list_sort_by_date;
    private automaticLoad = true;
    public currentMonth: string;
    public superStatus: any = superStatus;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private modalService: NgbModal,
        private draftService: DraftService,
        private generalService: GeneralService,
        private userDataService: UserDataService,
        private normalizadorService: NormalizadorService,
        private mobilePackService: MobilePackService,
        private listadoActivacionesService: ListadoActivacionesService,
    ) {
    }

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            full_name: [''],
            document: [''],
            msisdn_fijo: [''],
            msisdn_movil: [''],
            min_date: [''],
            max_date: [''],
            status: [''],
            contract_type: [''],
            sort_by_date: ['desc']
        });

        this.getOrders();
        this.getMothlyData();
        this.currentMonth = moment().locale('es').format('MMMM');
    }

    getOrders() {
        this.loaded = false;

        this.listadoActivacionesService.filterOrders(this.body).subscribe((data: any) => {
            this.processData(data);
        }, fail => {
            console.log(fail);
        });
    }

    getStateCoverage(order_id) {
        this.listadoActivacionesService.getStateCoverage(order_id)
            .subscribe(state => {
                console.log('Estado fijo', state);
            });
    }

    getMothlyData() {
        this.getActivationThisMonth(null);
        this.getRequestThisMonth(null);
        this.getAlertThisMonth(null, 1);
        this.getSuspendedThisMonth(null);
    }

    getActivationThisMonth(body) {
        this.isAlertView = false;
        const filters = [];
        const aux: any = {
            limit: 50,
            page: 1,
            order: {
                created_at: 'desc'
            }
        };

        filters.push({
            group_logic: 'and',
            and: {
                status: 'eq:3'
            }
        });

        filters.push({
            group_logic: 'and',
            and: {
                created_at: 'gte:' + moment().startOf('month').format('YYYY-MM-DD')
            }
        });

        aux.filters = filters;

        if (body) {
            this.orders = [];
            this.ordersFiltered = [];
            this.loaded = false;
            this.body = aux;
        }

        this.listadoActivacionesService.filterOrders(aux)
            .subscribe((data: any) => {
                if (data) {
                    this.activationThisMonth = data.msg.total;
                    if (body) {
                        this.processData(data);
                    }
                }
            }, fail => {
                console.log(fail);
            });
    }

    getRequestThisMonth(body) {
        this.isAlertView = false;
        const filters = [];
        const aux: any = {
            limit: 50,
            page: 1,
            order: {
                created_at: 'desc'
            }
        };

        filters.push({
            group_logic: 'and',
            and: {
                created_at: 'gte:' + moment().startOf('month').format('YYYY-MM-DD')
            }
        });

        aux.filters = filters;

        if (body) {
            this.orders = [];
            this.ordersFiltered = [];
            this.loaded = false;
            this.body = aux;
        }

        this.listadoActivacionesService.filterOrders(aux)
            .subscribe((data: any) => {
                if (data) {
                    this.requestThisMonth = data.msg.total;
                    if (body) {
                        this.processData(data);
                    }
                }
            }, fail => {
                console.log(fail);
            });
    }

    getAlertThisMonth(body, page) {
        const aux = '?limit=50&page=' + page + '&startDate=' + moment().startOf('month').format('YYYY-MM-DD') + '&endDate=' + moment().format('YYYY-MM-DD') + '&daysPending=7';

        if (body) {
            if (page === 1) {
                this.orders = [];
                this.ordersFiltered = [];
            }
            this.loaded = false;
        }

        this.body.limit = 50;
        this.body.page = page;
        this.listadoActivacionesService.filterAlerts(aux)
            .subscribe((data: any) => {
                if (data) {
                    this.alertThisMonth = data.msg.total;
                    if (body) {
                        this.processData(data);
                    }
                }
            }, fail => {
                console.log(fail);
            });
    }

    getSuspendedThisMonth(body) {
        const filters = [];
        const aux: any = {
            limit: 50,
            page: 1,
            order: {
                created_at: 'desc'
            }
        };

        filters.push({
            group_logic: 'and',
            and: {
                status: 'eq:4'
            }
        });

        filters.push({
            group_logic: 'and',
            and: {
                created_at: 'gte:' + moment().startOf('month').format('YYYY-MM-DD')
            }
        });

        aux.filters = filters;

        if (body) {
            this.orders = [];
            this.ordersFiltered = [];
            this.loaded = false;
            this.body = aux;
        }

        this.listadoActivacionesService.filterOrders(aux).subscribe((data: any) => {
            if (data) {
                this.suspendedThisMonth = data.msg.total;
                if (body) {
                    this.processData(data);
                }
            }
        }, fail => {
            console.log(fail);
        });
    }

    processData(data: any) {
        this.loaded = true;
        let auxOrders = this.orders.concat(data.msg.data);
        auxOrders.map(order => {
            if (order.mobiles && order.mobiles.length > 1) {
                order.mobiles.sort((a,b) => (a.principal) ? 1 : 0);
            }
        })
        this.orders = auxOrders;

        this.ordersFiltered = this.orders;
        this.lastPage = data.msg.last_page;
        this.pages = Array(this.lastPage).fill(1).map((x, i) => i);
    }

    advanceSearch() {
        this.isAlertView = false;
        const formData = this.formGroup.getRawValue();
        const filters = [];

        if (formData.full_name !== '') {
            filters.push({
                group_logic: 'and',
                and: {
                    customer_full_name: 'ct:' + formData.full_name
                }
            });
        }

        if (formData.document !== '') {
            filters.push({
                group_logic: 'and',
                and: {
                    customer_document: 'ct:' + formData.document
                }
            });
        }

        if (formData.msisdn_fijo !== '') {
            filters.push({
                group_logic: 'and',
                or: {
                    'broadband.new_msisdn': 'ct:' + formData.msisdn_fijo,
                    'broadband.msisdn': 'ct:' + formData.msisdn_fijo
                }
            });
        }

        if (formData.msisdn_movil !== '') {
            filters.push({
                group_logic: 'and',
                or: {
                    'mobiles.new_msisdn': 'ct:' + formData.msisdn_movil,
                    'mobiles.msisdn': 'ct:' + formData.msisdn_movil
                }
            });
        }

        if (formData.status) {
            filters.push({
                group_logic: 'and',
                and: {
                    status: 'eq:' + formData.status
                }
            });
        }

        if (formData.contract_type) {
            filters.push({
                group_logic: 'and',
                and: {
                    type: 'eq:' + formData.contract_type
                }
            });
        }

        if (formData.sort_by_date) {
            this.body.order.created_at = formData.sort_by_date;
        }

        if (formData.min_date != null && formData.max_date != null && formData.min_date !== '' && formData.max_date !== '') {
            filters.push({
                group_logic: 'and',
                and: {
                    created_at: 'bt:' + moment(formData.min_date).format('YYYY-MM-DD') + ',' + moment(formData.max_date).format('YYYY-MM-DD')
                }
            });
        } else if (formData.min_date != null && formData.min_date !== '') {
            filters.push({
                group_logic: 'and',
                and: {
                    created_at: 'gte:' + moment(formData.min_date).format('YYYY-MM-DD')
                }
            });
        } else if (formData.max_date != null && formData.max_date !== '') {
            filters.push({
                group_logic: 'and',
                and: {
                    created_at: 'lte:' + moment(formData.max_date).format('YYYY-MM-DD')
                }
            });
        }

        this.body.page = 1;
        this.body.filters = filters;
        this.orders = [];
        this.ordersFiltered = [];
        this.automaticLoad = true;

        this.getOrders();
    }

    convertDate(data): string {
        return moment(data).format('DD/MM/YYYY, hh:mm a');
    }

    convertStatusClass(status): string {
        switch (status) {
            case superStatus.active:
                return 'dot-complete';
            case superStatus.cancelled:
                return 'dot-cancel';
            default:
                return 'dot-pending';
        }
    }

    searchClient(text) {
        this.ordersFiltered = this.orders.filter(item => {
            const fullName: string = item.customer_full_name.toLowerCase();
            const fullNameNormalized = fullName.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            let document: string;
            if (item.customer_document) {
                document = item.customer_document.toLowerCase();
            }

            return document ? fullName.includes(text.toLowerCase()) || fullNameNormalized.includes(text.toLowerCase()) || document.includes(text.toLowerCase()) : fullName.includes(text.toLowerCase()) || fullNameNormalized.includes(text.toLowerCase());
        });
    }

    openModal(content) {
        this.modalService.open(content, {size: 'md', centered: true});
    }

    continueProcess(order: any) {
        const url = order.type === 'convergent' ? 'amena/convergente' : 'amena/solo_movil';

        this.resumeOrder(order, url);
    }

    resumeOrder(order: any, url: string) {
        const userData = new UserDataModel();
        let userDataBankForm: any;
        let normalizacionForm: any;
        let coberturaForm: any;
        const mobilePacks: any[] = [];

        userData.doctype = order.customer_document_type ? order.customer_document_type.digo_code : null;
        userData.doc = order.customer_document;
        userData.country = order.customer_nationality ? order.customer_nationality.code : null;
        userData.firstName = order.customer_name;
        userData.surname1 = order.customer_last_name;
        userData.surname2 = order.customer_second_last_name;
        userData.birthday = order.customer_birth_date;
        userData.sex = order.customer_gender;
        // userData.company = null;
        userData.phone = order.customer_phone_number;
        userData.email = order.customer_email;

        userData.bankingData.bank_account = order.iban;

        if (order.payer == null) {
            userDataBankForm = {
                bank_account: order.iban,
                account_doctype: order.customer_document_type != null ? order.customer_document_type.code : null,
                account_doc: order.customer_document,
                // account_country: order.customer_nationality != null ? order.customer_nationality.code : null,
                account_firstName: order.customer_name,
                account_surname1: order.customer_last_name,
                account_surname2: order.customer_second_last_name,
                account_company: '',
            };

            userData.bankingData.account_doctype = order.customer_document_type != null ? order.customer_document_type.code : null;
            userData.bankingData.account_doc = order.customer_document;
            // userData.bankingData.account_country = order.customer_nationality != null ? order.customer_nationality.code : null;
            userData.bankingData.account_firstName = order.customer_name;
            userData.bankingData.account_surname1 = order.customer_last_name;
            userData.bankingData.account_surname2 = order.customer_second_last_name;
            // userData.bankingData.account_birthday = order.customer_birth_date;
            // userData.bankingData.account_sex = order.customer_gender;
            // userData.bankingData.account_company = null;
            // userData.bankingData.account_phone = order.customer_phone_number;
            // userData.bankingData.account_email = order.customer_email;
        } else {
            userDataBankForm = {
                bank_account: order.iban,
                account_doctype: order.payer.document_type.code,
                account_doc: order.payer.document,
                // account_country: '',
                account_firstName: order.payer.name,
                account_surname1: order.payer.last_name,
                account_surname2: order.payer.second_last_name,
                account_company: '',
            };

            userData.bankingData.account_doctype = order.payer.document_type.code;
            userData.bankingData.account_doc = order.payer.document;
            // userData.bankingData.account_country = order.payer.customer_nationality.code;
            userData.bankingData.account_firstName = order.payer.name;
            userData.bankingData.account_surname1 = order.payer.last_name;
            userData.bankingData.account_surname2 = order.payer.second_last_name;
            // userData.bankingData.account_birthday = null;
            // userData.bankingData.account_sex = null;
            // userData.bankingData.account_company = null;
            // userData.bankingData.account_phone = null;
            // userData.bankingData.account_email = null;
        }

        for (const address of order.addresses) {
            if (address.type === 'postal') {
                userData.tipoVia = address.street_type;
                userData.nombreVia = address.street_name;
                userData.numero = address.street_number;
                userData.codigoPostal = address.post_code;
                userData.localidad = address.city;
                userData.provincia = address.province;
            }

            if (address.type === 'installation') {
                normalizacionForm = {
                    codigoPostalNormaliza: address.post_code,
                    localidadNormaliza: address.city,
                    nombreViaNormaliza: address.street_name,
                    numeroNormaliza: address.street_number,
                    provinciaNormaliza: address.province,
                    tipoViaNormaliza: address.street_type,
                };

                coberturaForm = {
                    localidadCobertura: address.city,
                    direccionesCobertura: address.street_name,
                    tipoViaCobertura: address.street_type,
                    nombreViaCobertura: address.street_name,
                    numeroCobertura: address.street_number,
                    provinciaCobertura: address.province,
                    codigoPostalCobertura: address.post_code,
                    plantaCobertura: address.floor_number,
                    bisCobertura: address.apartment_number,
                    bloqueCobertura: '',
                    portalCobertura: '',
                    escaleraCobertura: address.staircase_number,
                    tipoPuertaCobertura: '',
                    puertaCobertura: address.apartment_number,
                    resultadoConsultaCobertura: '',
                    portabilidadFijo: '',
                    tipoAltaFijo: ''
                };
            }
        }

        order.mobiles.forEach((mobile, index) => {
            const stepper_index = index + (order.type === 'convergent' ? 1 : 0);

            mobilePacks.push({
                type_operation: mobile.portability,
                rate: mobile.rate,
                principal: mobile.principal,
                portability_phone: mobile.msisdn,
                portability_operator: '',
                portability_type_client: '',
                portability_iccid: mobile.old_iccid,
                portability_client: mobile.old_contract_type,
                iccid: mobile.new_iccid,
                terminal: mobile.terminal,
                terminal_payment_type: mobile.terminal_vap ? 'VAP' : 'unico',
                terminal_insurance: '',
                stepper_index
            });
        });

        console.log('[RESUME ORDER - UserData]', userData);
        console.log('[RESUME ORDER - UserDataBank]', userDataBankForm);
        console.log('[RESUME ORDER - Normalización]', normalizacionForm);
        console.log('[RESUME ORDER - Cobertura]', coberturaForm);
        console.log('[RESUME ORDER - MobilePacks]', mobilePacks);

        this.draftService.setOrderIdDraft(order.order_id);
        // this.generalService.setEmptyFormNormalizacion(normalizacionForm);
        // this.generalService.setEmptyFormCobertura(coberturaForm);
        // this.generalService.setEmptyFormMobilePackAll(mobilePacks);
        this.generalService.setEmptyFormUserData(userData);
        this.generalService.setEmptyFormUserDataBank(userDataBankForm);


        this.modalService.dismissAll();
        this.router.navigate([url]);
    }

    setMinDate(event: MatDatepickerInputEvent<Date>) {
        this.minDate = event.value;
    }

    setMaxDate(event: MatDatepickerInputEvent<Date>) {
        this.maxDate = event.value;
    }

    updateAnnotation(order, annotation) {
        this.savingAnnotation = order.order_id;

        this.listadoActivacionesService.updateAnnotation(order.order_id, annotation).subscribe(data => {
            console.log(data);
            order.annotation = annotation;
            this.savingAnnotation = -1;
        }, error => {
            console.error('ERROR updateAnnotation', error);
            this.savingAnnotation = -1;
        });
    }

    @HostListener('window:scroll', ['$event'])
    doSomethingOnWindowScroll(event: Event) {
        if (this.automaticLoad) {
            const element: any = event.srcElement;
            const scrollOffset = element.children[0].scrollTop;
            const windowHeight = document.documentElement.scrollHeight - window.innerHeight - 200;

            if (scrollOffset > windowHeight) {
                console.log('Cargando siguiente página. A partir de ahora se carga en manual.');
                this.automaticLoad = false;
                this.nextPage();
            }
        }
    }

    prevPage() {
        if (this.body.page > 1) {
            this.body.page -= 1;
            this.getOrders();
        }
    }

    nextPage() {
        if (this.body.page < this.lastPage) {
            this.body.page += 1;
            this.isAlertView ? this.getAlertThisMonth(true, this.body.page) : this.getOrders();
        }
    }

    goPage(page) {
        if (page >= 1 && page <= this.lastPage) {
            this.body.page = page;
            this.getOrders();
        }
    }

    loadMore() {
        this.nextPage();
    }

    compare( a, b ) {
        if ( a.last_nom < b.last_nom ){
            return -1;
        }
        if ( a.last_nom > b.last_nom ){
            return 1;
        }
        return 0;
    }
}
